import { Component, OnInit } from "@angular/core";
import { ViewController } from "ionic-angular/navigation/view-controller";

@Component({
  selector: "kih-import-modal",
  templateUrl: "kih-import.modal.html"
})
export class KihImportModal implements OnInit {
  constructor(
    private viewCtrl: ViewController
  ) {}

  ngOnInit() {}

  dismiss($event) {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/kih-import.modal/kih-import.modal.ts